declare var appConfig: any;

import { InjectionToken } from '@angular/core';
import { concat } from 'rxjs/operators';

export interface IAppConfig {
    apiEndpoint: string;
    reportAccessTokenEndpoint: string;
    title: string;
    baseUrl: string;
    a2d_nt: string;
    a2d_ct: string;
}

export const APP_DI_CONFIG: IAppConfig = {
    apiEndpoint: appConfig.apiUrl,
    reportAccessTokenEndpoint: appConfig.reportAccessTokenEndpoint,
    title: 'Compliance Monitoring and Reporting System',
    baseUrl: appConfig.baseUrl,
    a2d_nt: appConfig.a2d_nt,
    a2d_ct: appConfig.a2d_ct
};

export let APP_CONFIG = new InjectionToken<IAppConfig>('app.config');

export const UploadFileRestrictions = {
    fileType: ["jpg", "jpeg", "png"],
    fileSize: 26214400 //25mb
};

export const ComponentRestrictions = {
    currency: {
        max: 18,
        min: 0
    },
    date: {
        max: "12/31/2100",
        min: "01/01/1900",
        minYear: "1800",
        maxYear: "2100"
    },
    text: {
        max: 500,
        min: 0
    },
    textArea: {
        max: 500,
        min: 0
    }
};

export const StatementType = {
    operational: 1,
    financial: 2
}

export const StatementTypeName = {
    operational: "OPERATIONS",
    financial: "FINANCIAL"
}

export const CheckListEntryStatus = {
    BUSubmitted: 1,
    CEOSubmitted: 2,
    CEOReverted: 3,
    SHReverted: 4,
    SHSubmitted: 5,
    SFCSubmitted: 6,
    SFCReverted: 7,
    Draft: 8,
    CEOModified: 9,
    SFCModified: 10,
    SHModified:11
}

export const UserType= {
    SFC : 2,
    SH :3,
    CEO: 1,
    GBPR: 5,
    BU: 4
}

export const CheckListEntryMode = {
    HiddenMode: "HiddenMode",
    EditMode: "EditMode",
    ViewMode: "ViewMode",
}

//TODO: Move these to server side config - Security Risk
export const NotificationTypeId = {
    NotificationPriorDeadline : 8,
    NotificationSubsequentDeadline : 9
}

//TODO: Move these to server side config - Security Risk
export const NotificationTemplateId = {
    NotificationPriorOrSubsequentTemplateId: 1
}



export const FollowUpItemStatusIdColors = [
    // { id: 0, displayName: '--select--', color: '#FFFFFF40' },
    { id: 1, displayName: 'Completed', color: '#c7eed0' },
    { id: 2, displayName: 'In progress', color: '#fcfed0' },
    { id: 3, displayName: 'Open', color: '#ffffff' },
    { id: 4, displayName: 'Delayed', color: '#ffd0d0' },
    { id: 5, displayName: 'Ongoing', color: '#fcfed0' },
    { id: 6, displayName: 'On Hold', color: '#fcfed0' },
    { id: 7, displayName: 'Unknown', color: '#fcfed0' }
];

export const FollowUpColumnId = {

    UpdatedManagementComment:4

}

export const FollowUpItemResponseStatus = {
    Responded: "Responded",
    ResponsePending: "Response Pending",
    Default:" "
}

export const FollowUpItemResponseStatusDropDown = [
    { id: 1, displayName: 'Responded' },
    { id: 0, displayName: 'Response Pending' }
];



export const IncidentReportErrorMode = {
    IncidentReportRequird: 1,
    NonComplienceRequird:2
}


export const ChecklistNavigateOption = {
    ComplianceCertificate: "COMPL",
    ConsolidatedCertificate: "CONSO",
    ConsolidatedGroupCertificateViewCertificate: "VCCONGP",
    ConsolidatedGroupCertificate: "CONGP",
    History: "HISTO",
    Dashboard: "DASH",
    BUChecklist:"BUEN"
}

export const FileExtension  = {
    pdf: "pdf",
    word: "docx"
}

export const CertificateType = {
    ComplianceCertificate: 1,
    ConsolidatedGroupCertificate: 2,
    ConsolidatedCertificate: 3,
    ConsolidatedViewCertificate: 4
} 

//Defining Comment Types
export const CommentTypes = {
    General: 1,
    Revert: 2 
}

//Defining Error Codes for Concurrent Conflicts
export const ConcurrentErrorCodes = {
    ComplianceCertificateObsoleteError: "E0067",
    ConcurrentUserRevertApproveError: "E0066",
    ConcurrentUserDeletedItemEditError: "E0065",
    CommentDeleteError: "E0058"
}
